module.exports = __webpack_public_path__ + "img/5-supervalue-assist-emergency.1563aeaa.jpg";